import { all, fork } from "redux-saga/effects"

//public
import AuthSaga from "./auth/login/saga"
import LayoutSaga from "./layout/saga"
import dashboardSaga from "./dashboard/saga"
import rolesSaga from "./roles/saga"
import permissionsSaga from "./permissions/saga"
import UsersSaga from "./users/saga"
import ProductsSaga from "./products/saga"
import OperatorProductsSaga from "./operatorProducts/saga"
import ProductsChannelsSaga from "./channels/saga"
import ProductsCategoriesSaga from "./categories/saga"
import SuppliersSaga from "./suppliers/saga"
import riskManagementSaga from "./riskManagement/saga"
import BonusesSaga from "./Bonuses/saga"
import MultiBetBonusesSaga from "./MultiBetBonus/saga"
import Acca7Saga from "./Acca7/saga"
import JackpotsSaga from "./jackpots/saga"
import EventsSaga from "./events/saga"
import PromotionsSaga from "./Marketing/saga"
import StaticPagesSaga from "./StaticPages/saga"
import ShopsSaga from "./Admin/shops/saga"
import CashiersSaga from "./cashier/saga"
import ContentSaga from "./Content/saga"
import CampaignsSaga from "./Campaigns/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AuthSaga),
    fork(LayoutSaga),
    fork(dashboardSaga),
    fork(rolesSaga),
    fork(permissionsSaga),
    fork(UsersSaga),
    fork(ProductsSaga),
    fork(OperatorProductsSaga),
    fork(ProductsChannelsSaga),
    fork(ProductsCategoriesSaga),
    fork(SuppliersSaga),
    fork(riskManagementSaga),
    fork(BonusesSaga),
    fork(MultiBetBonusesSaga),
    fork(Acca7Saga),
    fork(JackpotsSaga),
    fork(EventsSaga),
    fork(PromotionsSaga),
    fork(StaticPagesSaga),
    fork(CampaignsSaga),
    fork(ShopsSaga),
    fork(CashiersSaga),
    fork(ContentSaga),
  ])
}
